// @ts-ignore
import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../base/icons/components/Icon';
import { IconQuestionCircle } from '../../base/icons/svg';
import Popover from "../../base/popover/components/Popover.web";
const useStyles = makeStyles()(() => {
    return {
        parent: {
            display: 'inline',
            fontFamily: 'Lato Regular',
            fontWeight: 'normal',
            fontSize: '15px',
            lineHeight: '22px',
            marginRight: '25px',
            // Apply display: inline to all child elements
            '& *': {
                display: 'inline !important',
                verticalAlign: 'middle',
            },
        },
        iconWrapper: {
            marginLeft: '6px',
            marginTop: '2px'
        },
        popoverContent: {
            padding: '5px 8px',
            fontSize: '13px',
            lineHeight: '18px',
            backgroundColor: '#272727',
            maxWidth: '186px',
            borderRadius: '5px',
            marginBottom: '9px',
            cursor: 'pointer'
        },
        popoverTriangle: {
            position: 'absolute',
            left: '50%',
            bottom: '-12px',
            transform: 'translateY(-50%)',
            width: '0',
            height: '0',
            borderLeft: '5px solid transparent',
            borderRight: '5px solid transparent',
            borderTop: '8px solid #272727',
        }
    };
});
function getOS() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/win(dows)?/i.test(userAgent)) {
        return 'Windows&nbsp;10+';
    }
    else if (/macintosh|mac os x/i.test(userAgent)) {
        return 'MacOS&nbsp;13+';
    }
    return 'Ubuntu&nbsp;18+, Debian&nbsp;10+, Fedora&nbsp;32+, Centos&nbsp;8+, Alt&nbsp;10+';
}
const unsupportedText = (props) => {
    const { classes: styles, cx, theme } = useStyles();
    const { t } = props;
    return (React.createElement("div", { className: cx(styles.popoverContent) },
        React.createElement("div", { dangerouslySetInnerHTML: { __html: t('dialog.screenSharingAudioNotAvailableOS', { os: getOS() }) } }),
        React.createElement("span", { className: cx(styles.popoverTriangle) })));
};
const DesktopPickerUnsupportedSound = (props) => {
    const { classes: styles, cx, theme } = useStyles();
    const { t } = props;
    const [isOpen, changeOpenState] = useState(false);
    return (React.createElement("div", { className: cx(styles.parent) },
        React.createElement("span", null, t('dialog.screenSharingAudioNotAvailable')),
        React.createElement(Popover, { content: unsupportedText(props), onPopoverClose: () => changeOpenState(false), position: 'top', trigger: 'click', visible: isOpen },
            React.createElement("div", { className: cx(styles.iconWrapper), onMouseLeave: () => changeOpenState(false), onClick: () => changeOpenState(true), onMouseEnter: () => changeOpenState(true) },
                React.createElement(Icon, { color: theme.palette.icon03, size: 20, src: IconQuestionCircle })))));
};
export default DesktopPickerUnsupportedSound;
